export const APP_NAME = '5TechG Lab LLP'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const REFERRAL_URL_KEY = 'referralUrl'
